import { PROFORMA_FORMS } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggProformaFormsToLegacyField: FieldTransformer<typeof PROFORMA_FORMS> = (
	node,
) => {
	if (node.type !== PROFORMA_FORMS) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: node.proformaForms,
		schema: {
			configuration: null,
			items: null,
			system: PROFORMA_FORMS,
			custom: null,
			renderer: null,
			type: PROFORMA_FORMS,
		},
	};
};
